import React, { useEffect, useState } from "react";
import "./WeatherDataTable.css";
import axios from "axios";
import ToggleViewBmsk from "./ToggleView/ToggleViewBmsk";
import DoughnutChart from "./DoughnutChart";
import HalfDoughnutChart from "./HalfDoughnutChart";
import HorizontalBarChart from "./HorizontalBarChart";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { getBMSKData } from "../../../Services/EndPoints";
import { getData } from "../../../Services/Services";
import { Expand } from "../../../Components/IconComponents";

const WeatherDataTable = ({
  affectedDistrictData,
  affectedBlockData,
  affectedNagarNigamData,
  affectedPanchayatData,
  fromDate,
  toDate,
}) => {
  const [weatherApiData, setWeatherApiData] = useState([]);
  const [activeTabBmsk, setActiveTabBmsk] = useState("Charts"); // Set default to "Charts"
  const [expandedRows, setExpandedRows] = useState([]);
  const { t } = useTranslation();

 

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}${month}${year}`;
  };

  const formatDates = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const todayDate = formatDate(new Date());
  const todayDates = formatDates(new Date());

  const toggleRowExpand = (index) => {
    setExpandedRows((prev) => (prev === index ? null : index)); // Allow only one expanded row
  };

  console.log(todayDate, "todaydate");

  useEffect(() => {
    const fetchWeatherData = async () => {
      try {
        const response = await getData(
          getBMSKData.replace("FROMDATE", todayDate)
        );
        setWeatherApiData(response.path);
        console.log(response.path);
      } catch (error) {
        console.error("Error fetching weather data:", error);
      }
    };

    fetchWeatherData();
  }, [todayDate]);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 6,
      height: 4,
      id: 7,
      component: (
        <DoughnutChart
          title={t("flooddisaster.doughnutchart1")}
          dataval={affectedDistrictData}
          startDateStr={moment(fromDate).format("YYYY-MM-DD")}
          endDateStr={moment(toDate).format("YYYY-MM-DD")}
          partial={true}
          showViewIcon={true}
        />
      ),
    },
    {
      x: 6,
      y: 0,
      width: 6,
      height: 4,
      id: 8,
      component: (
        <HalfDoughnutChart
          startDateStr={moment(fromDate).format("YYYY-MM-DD")}
          endDateStr={moment(toDate).format("YYYY-MM-DD")}
          title={t("flooddisaster.doughnutchart2")}
          dataval={affectedBlockData}
          partial={true}
          showViewIcon={true}
        />
      ),
    },
    {
      x: 0,
      y: 4,
      width: 6,
      height: 5,
      id: 10,
      component: (
        <HorizontalBarChart
          title={t("flooddisaster.doughnutchart3")}
          dataval={affectedNagarNigamData}
          showAffectedCount={true}
        />
      ),
    },
    {
      x: 6,
      y: 4,
      width: 6,
      height: 5,
      id: 12,
      component: (
        <HorizontalBarChart
          title={t("flooddisaster.doughnutchart4")}
          dataval={affectedPanchayatData}
          showAffectedCount={true}
        />
      ),
    },
  ];

  return (
    <div>
      <div
        className={
          activeTabBmsk === "Charts"
            ? "header-container"
            : "header-container-chart"
        }
      >
        {activeTabBmsk === "BMSK" ? (
          <span className="p-data">
            Data received {" "}
            {/* {new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}{" "} */}
            on {todayDates}
          </span>
        ) : null}
        {/* <div className="toggle-container">
          <ToggleViewBmsk
            className={
              activeTabBmsk === "Charts" ? "button-Charts" : "button-BMSK"
            }
            setActiveTabBmsk={setActiveTabBmsk}
            activeTabBmsk={activeTabBmsk}
          />
        </div> */}
      </div>

      <div className="charts-grid-wrapper">
        {activeTabBmsk === "Charts" && (
          <div className="grid-stack grid-stack-instance-1 mt-1">
            {layoutData.map((gridItem) => (
              <div
                className="grid-stack-item"
                gs-x={gridItem.x}
                gs-y={gridItem.y}
                gs-w={gridItem.width}
                gs-h={gridItem.height}
                key={gridItem.id}
              >
                <div className="grid-stack-item-content">
                  {gridItem.component}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WeatherDataTable;
